import React, { useEffect } from "react";
import Aimlbanner from "./Aimlbanner";
import Aimlsolution from "./Aimlsolution";
import Poweraiml from "./Poweraiml";
import Aimlfeatures from "./Aimlfeatures";
import Aimlbanners from "./Aimlbanners";

const Aiml = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        backgroundImage:
          "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <Aimlbanners />
        <Aimlbanner />
        <Aimlsolution />

        <Poweraiml />
        <Aimlfeatures />
      </div>
    </div>
  );
};

export default Aiml;
